export enum ProfileApplicationsStatus {
  accepted = 1,
  review = 2,
  approved = 3,
  rejected = 4,
}
